import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  titulos: {
    margin: '8px 0px',
  },
});
